import React from 'react';
import {concepts, File, Group, Reagent, useDelayedState, User} from "fearless-common";
import {adminRoutes} from "../../../utils/routes";
import Pages from "../../../components/layout/Pages";
import OrderableTable from "../../../components/layout/OrderableTable";
import {backendEndpoints} from "../../../libs/backendEndpoints";
import Description from "../../../components/Description";
import {ColumnDef} from "@tanstack/react-table";
import SearchInput from "../../../components/SearchInput";
import {UserNameSpan, useTitle} from "fearless-common-ui";
import useGet from "../../../components/hooks/useGet";
import CellRender from "../../../components/layout/table/CellRender";

type ExtendedFile = File & { exists: boolean; reagent: Reagent };

const columns: ColumnDef<ExtendedFile>[] = [
    { id: 'id', accessorKey: 'id', header: 'ID' },
    { id: 'name', accessorKey: 'name', header: 'Name' },
    // @ts-ignore
    { id: 'user', accessorKey: 'reagent.user', header: 'User ID', cell: ({ value, row }) => !value ? '-' : <a href={adminRoutes.user(row.original.user?.id)}><UserNameSpan user={value} inline /></a>},
    // @ts-ignore
  {
    id: 'group',
    // @ts-ignore
    accessorKey: 'reagent.group',
    header: 'Group',
    // @ts-ignore
    cell: ({ value, row }) => !value ? '-' :
      <a href={adminRoutes.user(value?.id)}>{value.name}</a>
  },
  {id: 'path_s3', accessorKey: 'path_s3', header: 'File path'},
  {id: 'exists', accessorKey: 'exists', header: 'Exists on AWS S3 Storage', cell: CellRender.Bool },
    { id: 'created_at', accessorKey: 'created_at', header: 'Created at', cell: CellRender.DateTime },
    { id: 'updated_at', accessorKey: 'updated_at', header: 'Updated at', cell: CellRender.DateTime },
    { id: 'deleted_at', accessorKey: 'deleted_at', header: 'Deleted at', cell: CellRender.DateTime },
];

/**
 * Show a table of all institutes.
 */
export default function AdminFiles() {
  useTitle(`Admin Files`);
  const { data: users } = useGet<User[]>({
    endpoint: adminRoutes.adminFiltersUser
  });
  const { data: groups } = useGet<Group[]>({
    endpoint: adminRoutes.adminFiltersGroup
  });
  const [query, setQuery] = useDelayedState('');
    return (
        <Pages.Centred padded>
          <div className="d-flex align-items-center gap-4">
            <h1 className="flex-grow-1">Files</h1>
            <div className="ms-3">
              <SearchInput
                onChange={(e) => {
                  // @ts-ignore
                  setQuery(e.target.value);
                }}
              />
            </div>
          </div>
          <Description className="neutral-500">
            All {concepts.Photo51} files in the system.
          </Description>
          <OrderableTable<ExtendedFile>
            orderables={{
              'name': 'name',
            }}
            filterables={[
              {
                field_name: 'deleted_at',
                label: 'Archived',
                options: [
                  {value: 'null', label: 'Active'},
                  {value: 'not null', label: 'Archived'},
                ],
              },
              {
                field_name: 'user_id',
                label: 'User',
                options: (users || []).map((u) => ({ value: u.id.toString(), label: `${u.first_name} ${u.last_name} - ID ${u.id}`}))
              },
              {
                field_name: 'group_id',
                label: 'Group',
                options: (groups || []).map((group) => ({ value: group.id.toString(), label: group.name }))
              }
            ]}
            pagination
            baseEndpoint={backendEndpoints.getAdminFiles}
            memoisedColumns={columns}
            buildLink={(record) => adminRoutes.file(record.id)}
            // @ts-ignore
            searchQuery={query}
          />
        </Pages.Centred>
    );
}
